<template>
    <el-dialog class="download-select"
             size="tiny"
             :visible.sync="show"
             :title="$t('retailInstance.text.downloadShow')"
             :close-on-click-modal="false"
             :before-close="handleClose">
        <el-form label-width="130px">
            <el-form-item :label="$t('retailInstance.text.downloadRange') | withColon">
                <el-radio-group v-model="selectDownloadType">
                    <el-radio :label="0" class="download-radio">{{$t('retailInstance.text.downloadAll')}}</el-radio>
                    <el-radio :label="1" class="download-radio-middle" :disabled ="this.multipleSelection.length === 0 ? true : false" >{{$t('retailInstance.text.downloadSelect')}}</el-radio>
                    <el-radio :label="2" class="download-radio">{{$t('retailInstance.text.downloadSearch')}}</el-radio>
                </el-radio-group>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
        <el-button @click="cancelDownload">{{ $t('privateNetInstance.cancel') }}</el-button>
        <el-button @click="sureDownload" type="primary">{{ $t('privateNetInstance.sure') }}</el-button>
        </div>
    </el-dialog>
</template>

<script>
    export default {
      name: "download",
      props: {
        visible: {
            type: Boolean,
            default: false
        },
        instanceId: {
            type: String,
            default: ''
        },
        currentPage: {
            type: Number,
            default: 1
        },
        pageSize: {
            type: Number,
            default: 20
        },
        region: {
            type: String,
            default: ''
        },
        multipleSelection: {
            type: Array,
            default: []
		},
        searchParams: {
            type: Object,
            default: {},
        },
        networkType: {
            type: String,
            default: ''
        },
        filterParams: {
            type: Object,
            default:  {
                az: '',
                interfaceMode: '',
                deviceType: '',
                status: ''
                },
        }
      },
      data() {
        return {
          show: false,
          selectDownloadType: 0,
          instanceIdsString:[],
        }
      },
      methods: {
        handleClose() {
          this.show = false;
          this.selectDownloadType = 0;
          this.$emit('update:visible', false);
        },
        cancelDownload() {
          this.handleClose();
        },
        sureDownload() {
          this.downloadList();
        },
        // 下载列表
	    downloadList() {
            if(this.selectDownloadType === 1){
                let instanceIds = this.multipleSelection.map(item => item.instanceId);
                this.instanceIdsString = instanceIds.toString();
            }else{
                this.instanceIdsString = [];
            };
			const params = {
				region: this.region,
				pageNumber: this.currentPage,
				pageSize: this.pageSize,
				networkType: this.networkType,
                instanceIds: this.instanceIdsString,
                exportType: this.selectDownloadType
			};
			Object.keys(this.filterParams).forEach((param) => {
				if (this.filterParams[param] !== '') {
					params[param] = this.filterParams[param];
				}
			});
            if(this.selectDownloadType !== 2) {
                this.searchParams = {};
            };
            const realParams = Object.assign({}, params, this.searchParams);

	    	Ajax.download('GET', '/api/export/listInstances', realParams, { baseURL: '/cps_api' })
            .then((res) => {
				this.$message.success(this.$t('retailInstance.text.downloadSuccess'));
			})
            .catch(async (err) => {
				const { response } = err.data;
				try {
					const json = await response.json();
					this.$message.error(json.errmsg);
				} catch (ex) {
					console.log(ex);
				}
			})
            .finally(() => {
                this.handleClose();
			});;
	    },
      },
      watch: {
        visible(newVal) {
          this.show = newVal;
        }
      }
    }
</script>

<style lang="scss">
    .download-select {
        .download-radio {
            display: block;
            margin: 10px;
        }

        .download-radio-middle {
            display: block;
            margin: 20px 10px 20px 10px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/common/retailInstance/DownloadSelection.vue